export interface CountryView {
  readonly id: string;
  readonly lon: number;
  readonly lat: number;
  readonly zoom: number;
}

export function countryAtView(
  opening: CountryView | null,
  camera: { readonly lon: number; readonly lat: number; readonly zoom: number },
): string | null {
  if (!opening) return null;
  const dx = Math.abs(opening.lon - camera.lon) % 360;
  return Math.min(dx, 360 - dx) <= 0.0051 &&
    Math.abs(opening.lat - camera.lat) <= 0.0051 &&
    Math.abs(opening.zoom - camera.zoom) <= 0.0051
    ? opening.id
    : null;
}
